import { getLink } from '../../../utils/utils';

import author from './author';

const cite1Text = (
  `El Puŝkin: «Да здравствует Солнце! Да скроется тьма»!`
)
const cite1 = (
  `<sup><acronym title="${cite1Text}"><a href="#cite_note1" id="cite_ref1">[1]</a></acronym></sup>`
)

const content = {
  esp: (
    `
			<div style="text-align: justify;">
				<p class="mb-3">
					Ĉiuj certe scias, ke la Muzoj jam antaŭlonge estas mortaj: pro neniigo de iliaj vivmedioj, pro sufokiĝo, pro kaduko… 
					Formortis ili same kiel aliuj personigoj de viva naturo: nimfoj, satirusoj… 
					Ja ĉiuj ili estis partoj de naturo, la reprezentoj de kreaj kaj ekkonaj fortoj de Homo, vivanta homo.
				</p>
				
				<p class="mb-3">
					Sed kiu nun kreas, kiu ekkonas? 
					La cerboj estas inhibitaj ekde naskiĝo; kaj ekde tiam ili plenas nur de tio, kion oni inokulas al ili deekstere; 
					jam anticipe estas nuligita la bariero de kritika pensado, logika ekkonscio, propra kompreno de okazaĵoj kaj ilia interligiteco. 
					La cerbo nun funkcias kiel rekta intesto (Colon) de kaprino: ĝi eligas pensojn en formo de apartaj eldiroj ne kunligitaj unu kun la alia, 
					kvazaŭ buletoj de kaprina fekaĵo. Ĉe kaprino tio okazas pro la speciala funkciado de digesta tubo, kiu regule haltigas la fluon de la jam prilaborita manĝaĵo. 
					Sed same en la pensado: oni devas ja haltigadi la fluon de ricevita deekstere informo, jam prilaborita en formo de propraj pensoj! 
					Sed por garantii la foreston de interligo de pensoj necesas foresto de Memoro, kiu kunligas ilin!
				</p>
				
				<p class="mb-3">
					Kaj jen oni ekmemoris pri olda Mnemozina, la patrino de ĉiuj Muzoj, kiu iel perdiĝis dum la lastaj jarmiloj. 
					Ja homoj simple forgesis mitologion; forgesis, ke la bazo de ajna ekkono, ajna kreado estas Memoro, ebliganta iri antaŭen apogante sur pasintaj atingoj. 
					Ja senila demenco, kiu faras el homo aĵon, – estas nur la perdo de Memoro. 
				</p>
				
				<p class="mb-3">
					Kaj jen oni trovis la oldan M., tiel delonge akceptitan inter “modernaj valoroj”, ke ĝia suspektinda deveno jam estis plene forgesita. 
					Trovis, devualigis kaj alpuŝis por komuna hontigo kaj prirido. 
					Ne eblas, estas ne laŭmode, hontinde memori tion, kio estas dirita la horon antaŭe! 
					Ŝanĝiĝis jam reguloj, kaj oni devas pensi alion, kredi alion! Sed la pasinton – forgesi!
				</p>
				
				<p class="mb-3">
					Kaj Mnemozina estis publike kaj ekzemplodone mortpafita por edifo al ĉiuj herezuloj, kiuj dume arogas respekti ŝin. 
					Sed nelonge ja ili survivos kaj rezistos; baldaŭ ankaŭ ili formortos; kaj ni helpos al tio! 
				</p>
				
				<p class="mb-3">
					Do vuvu mallumo! Pereu la Sun’!${cite1}
				</p>
			</div>
    `
  )
}

const itemName = {
  esp: 'Mortigo de Mnemozina'
}

const itemDate = {
  esp: '26-27 aŭgusto 2022'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
		itemDate: itemDate.esp,
    itemContent: content.esp,
    itemAuthor: author.esp,
  }
}

export default item; 